module.exports = __webpack_public_path__ + "ad620d34a77843d289e35d2b5f24d43c.jpg";